<div>
  <div class="template-header-wrapper container">
    <div class="row">
      <ap-dropdown class="consol-group-dropdown"
                   [list]="consolGroups"
                   [selectType]="'single'"
                   [optionName]="'text'"
                   [title]="placeholderText" [inputAriaLabel]="'Consolidated group'"
                   [hideTitleOnInput]="true"
                   [(ngModel)]="selectedConsolGroupItem"
                   (onSelect)="onConsolGroupChanged($event)">
        @for (item of consolGroups; track $index) {
<ap-dropdown-list-item
                               #dropdownListItem
                               [item]="item"
                               [optionName]="'text'"
                               [ariaLabel]="setAriaLabel(item, 'Consolidated group')"
                               (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
      </ap-dropdown>
    </div>
    @if (!isBulk) {
<div class="row">
      <span class="tax-return-desc one-point-four">{{taxYear}} {{taxReturnDetails}}</span>
    </div>
}
    @if (!isBulk) {
<div class="row">
      <span class="form-name one-point-four">{{formName}}</span>
      @if (allowOptional) {
<span class="optional">
        <ap-dropdown class="option-selection" [list]="dropDownOptions || []" [selectType]="'single'" [title]="'Select'" [inputAriaLabel]="'Select'"
                     [hideTitleOnInput]="true" [(ngModel)]="selectedOption" (onSelect)="onOptionChanged($event)">
          @for (item of dropDownOptions || []; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                 [ariaLabel]="setAriaLabel(item, 'Select')"
                                 (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
        </ap-dropdown>
      </span>
}
      <span class="form-name same-line">&nbsp;{{sameLineText}}</span>
    </div>
}
    @if (extraLine) {
<div class="row">
      <span class="form-name one-point-four">{{extraLine}}</span>
    </div>
}
  </div>
</div>
